var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0158 4.89998C7.4166 4.89998 3.93162 8.07203 3.93162 11.7068C3.93162 13.0128 4.36923 14.2386 5.14169 15.2779C5.25705 15.4332 5.31934 15.6214 5.31934 15.8148C5.31934 17.1945 4.77963 18.4986 4.22038 19.7354C5.93378 19.5412 7.05532 18.9847 7.73306 18.1879C7.97889 17.8989 8.37958 17.795 8.73482 17.9283C9.73479 18.3036 10.8443 18.5136 12.0158 18.5136C16.6151 18.5136 20.1 15.3415 20.1 11.7068C20.1 8.07203 16.6151 4.89998 12.0158 4.89998ZM2.13162 11.7068C2.13162 6.82881 6.69139 3.09998 12.0158 3.09998C17.3403 3.09998 21.9 6.82881 21.9 11.7068C21.9 16.5847 17.3403 20.3136 12.0158 20.3136C10.8433 20.3136 9.71582 20.1358 8.66833 19.8081C7.42025 20.9611 5.61596 21.5128 3.4202 21.599C2.49327 21.6354 1.82177 20.6717 2.21117 19.8066C2.7397 18.6242 3.40839 17.4038 3.5087 16.0878C2.63785 14.8156 2.13162 13.3152 2.13162 11.7068Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageOutline);
export default __webpack_public_path__ + "static/media/message_outline.0836e8f94d089c76e2dbb83b07ddc9ac.svg";
export { ForwardRef as ReactComponent };